import { Injectable } from '@angular/core';
import { SessionService } from '@bayclubs/utils';
import { DefaultUrlSerializer } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class FiltersStorageService {
    private sessionStorageKeyPostfix = 'Url';

    constructor(private sessionService: SessionService) {}

    public getFilterValue(filterId: string, queryKey: string): string {
        let value = '';
        const url = this.getFilterUrl(filterId);

        if (url) {
            const defaultUrlSerializer = new DefaultUrlSerializer();
            const urlTree = defaultUrlSerializer.parse(url);
            value = urlTree.queryParamMap.get(queryKey);
        }

        return value;
    }

    public getFilterUrl(filterId: string): string {
        const urlSessionStorageKey: string = this.createSessionStorageKey(filterId);
        const urlItem = this.sessionService.getItem(urlSessionStorageKey, { url: null });
        return urlItem.url;
    }

    public setFilterUrl(filterId: string, newUrl: string): void {
        const urlSessionStorageKey: string = this.createSessionStorageKey(filterId);
        const newUrlItem = { url: newUrl };
        this.sessionService.setItem(urlSessionStorageKey, newUrlItem);
    }

    private createSessionStorageKey(filterId: string): string {
        return filterId + this.sessionStorageKeyPostfix;
    }
}
